// Sources belong to the revision; UUIDs survive edits and are never regenerated on render.
export class HandbookSourcesEditor {
  constructor(controller) {
    this.controller = controller
    const c = controller
    try {
      this.rows = JSON.parse(c.sourcesTarget.value)
      if (!Array.isArray(this.rows) || this.rows.some(row => !row || typeof row !== "object" || Array.isArray(row))) throw new Error("format")
      this.render()
    } catch {
      this.rows = null
      const recovery = c.node("textarea", { readOnly: true, className: "form-control", value: c.sourcesTarget.value })
      recovery.setAttribute("aria-label", "Zachowane źródła")
      c.sourceRowsTarget.replaceChildren(recovery)
    }
  }
  serialize() {
    if (this.rows) this.controller.sourcesTarget.value = JSON.stringify(this.rows)
  }
  add() {
    if (!this.rows) return
    this.rows.push({ id: crypto.randomUUID(), title: "", url: null, citation: "", accessed_on: null, note: "", public: false })
    this.render()
    this.controller.changed()
    this.controller.sourceRowsTarget.lastElementChild.querySelector("input").focus()
  }
  render() {
    const c = this.controller
    c.sourceRowsTarget.replaceChildren()
    this.rows.forEach((row, index) => {
      const card = c.node("fieldset", { className: "border rounded p-4 space-y-3" })
      card.dataset.sourceId = row.id
      card.append(c.node("legend", { textContent: `Źródło ${index + 1}` }))
      for (const [key, label] of [["title", "Tytuł źródła"], ["url", "URL"], ["citation", "Cytowanie / akt / artykuł"], ["accessed_on", "Data dostępu"], ["note", "Notatka wewnętrzna"]]) {
        const input = c.field(card, label, row[key] ?? "", value => { row[key] = ["url", "accessed_on"].includes(key) && value === "" ? null : value }, ["citation", "note"].includes(key) ? "textarea" : "input")
        if (key === "accessed_on") input.placeholder = "YYYY-MM-DD"
      }
      const label = c.node("label", { className: "flex gap-2" })
      const checkbox = c.node("input", { type: "checkbox", checked: row.public === true })
      checkbox.addEventListener("change", () => { row.public = checkbox.checked; c.changed() })
      label.append(checkbox, c.node("span", { textContent: "Pokaż publicznie" }))
      card.append(label, c.button("Usuń źródło", () => {
        this.rows.splice(index, 1); this.render(); c.changed()
        c.addSourceTarget.focus()
      }))
      c.sourceRowsTarget.append(card)
    })
  }
}
